'use client';
import Lottie from 'lottie-react';

// const LoaderAnimation = require('./assets/mainLoader.json');
import LoaderAnimation from './assets/mainLoader.json';
import { BoxComponent } from '../../base/box/Box';
//TODO: Change this 'require' import to regular import

export function LoaderMini({ ...otherProps }) {
  return (
    <BoxComponent
      sx={{
        height: '100px',
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(otherProps.sx || {}),
      }}
    >
      <Lottie animationData={LoaderAnimation} loop={true} />
    </BoxComponent>
  );
}
